/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon16Regular = forwardRef('ArrowAUpRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.25 3a.75.75 0 0 0 0 1.5h5.19l-7.47 7.47a.75.75 0 1 0 1.06 1.06l7.47-7.47v5.19a.75.75 0 0 0 1.5 0v-6A1.75 1.75 0 0 0 11.25 3h-6Z" })));
});
